module.exports = __webpack_public_path__ + "static/Muli-Italic-0cafc4c8901bd5a21e3b8be4fcf43fc0.woff2";